/**
 * Web Storage Implementation
 * 
 * Wraps localStorage behind the IStorage interface.
 * Provides both async (cross-platform) and sync (web-only) methods.
 */
import { IStorage } from '@watchlist/shared';

export class WebStorage implements IStorage {
    async getItem(key: string): Promise<string | null> {
        try {
            return localStorage.getItem(key);
        } catch {
            return null;
        }
    }

    async setItem(key: string, value: string): Promise<void> {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            console.error('WebStorage: Failed to set item', key, error);
        }
    }

    async removeItem(key: string): Promise<void> {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error('WebStorage: Failed to remove item', key, error);
        }
    }

    // Sync versions for backward compatibility
    getItemSync(key: string): string | null {
        try {
            return localStorage.getItem(key);
        } catch {
            return null;
        }
    }

    setItemSync(key: string, value: string): void {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            console.error('WebStorage: Failed to set item (sync)', key, error);
        }
    }

    removeItemSync(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error('WebStorage: Failed to remove item (sync)', key, error);
        }
    }
}
